<template>
  <box-model title="种植规模与占比情况">
    <template v-slot:content>
      <div class="container">
        <div class="tag-sty flex-center">
          <div v-for="(item, index) in tagList" :key="index" class="tag-item flex-y-center">
            <div class="tz" :style="`background:${colorArr[index]}`"></div>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="pie-sty">
          <div id="echart" class="con"></div>
          <div class="show-part flex-y-center">
            <div class="sm">
              <div class="s-title">总面积</div>
              <div class="s-con">{{ detail.totalArea || 0 }}<span class="t">亩</span></div>
            </div>
          </div>
        </div>
        <div class="line-sty">
          <div id="line" class="con"></div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { getPercentageOfCropArea, getTotalData, getVarietiesScale } from "@/api/index";
  export default {
    data() {
      return {
        detail: {},
        colorSty: {
          0: '#0994FF',
          1: '#38EAFF',
          2: '#06F7A1',
          3: '#FFCC00',
          4: '#FF6637',
          5: '#7458FF'
        },
        colorArr: ['#0994FF','#38EAFF','#06F7A1','#FFCC00','#FF6637','#7458FF'],
        show: false,

        tagList: []
      }
    }, 
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted(){
      this.getPercentageOfCropAreaEvent();
      this.getVarietiesScaleFn();
    },
    methods: {
      getPercentageOfCropAreaEvent() {
        getPercentageOfCropArea().then((res) => {
          this.detail = res.data || {};
          const result = res?.data?.vsRatio || [];
          this.tagList = result;
          result.forEach((item) => {
            item["name"] = item.varietiesName;
            item["value"] = item.area;
          })
          if(result.length){
            const that = this;
            let option = {
              tooltip : {
                trigger: 'item',
                formatter: function(item){
                  let result = `
                    <div style="padding: 12px;z-index:1001">
                      <div style="color: #3E3E3E;font-size: 16px;">${item.name}</div>
                      <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                      <div style="display: flex;align-items: center;">
                        <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                        <div style="color: #000E2B;font-size: 16px;margin-left: 4px;line-height: 16px;">种植面积：${item.value}亩</div>  
                      </div>
                    </div>
                  `;
                  return result;
                },
                backgroundColor: '#fff',
              },
              color: that.colorArr,
              series: [
                {
                  name: '资源总量构成',
                  type: 'pie',
                  center: ['50%', '45%'],
                  radius: ['50%', '70%'],
                  data: result,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  itemStyle: {
                    normal: {
                      label:{ 
                        show: true, 
                        formatter: function(param){
                          return `${param.name}：${Math.round(param.percent)}%`
                        },
                        fontSize : 16,
                      }
                    },
                    labelLine :{show:true}
                  }
                }
              ]
            };
            const myChart = echarts.init(document.getElementById("echart"));
            myChart.setOption(option);
          }
        });
      },
      init(option) {
        const myChart = echarts.init(document.getElementById("line"));
        myChart.setOption(option);
      },
      getVarietiesScaleFn() {
        getVarietiesScale().then((res) => {
          if(!res.data || !res.data?.length){
            this.show = false;
            return;
          };
          this.show = true;
          this.$nextTick(() => {
            const result = res.data;
            let name = [];
            let bData = {};
            // 获取作物名称与年份
            result.forEach((item) => {
              if(!bData[item.year]){
                bData[item.year] = [];
                bData[item.year].push({
                  value: item.area,
                  name: item.varietiesName
                });
              } else {
                bData[item.year].push({
                  value: item.area,
                  name: item.varietiesName
                });
              };
              if(!name.includes(item.varietiesName)){
                name.push(item.varietiesName);
              };
            });
            let copyBDate = JSON.parse(JSON.stringify(bData));
            for(let item in bData){
              let arr1 = bData[item];
              for(let i = 0; i<name.length;i++){
                let state = arr1.some((v) => v?.name === name[i]);
                if(!state){
                  copyBDate[item].push({
                    name: name[i],
                    value: 0
                  });
                }
              }
            };
            let seriesData = [];
            let yName = [];
            name.forEach((item, idx) => {
              let rdata = [];
              for(let v in copyBDate){
                if(!yName.includes(v)){
                  yName.push(v);
                }
                rdata.push(copyBDate[v].find((vi) => vi.name === item).value);
              };
              seriesData.push(this.getSeriesItem(item, idx, rdata));
            });
            const option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
                backgroundColor: '#fff',
                formatter: function(params){
                  let item = params[0];
                  let targetStr = []
                  for(let i = 0;i<params.length;i++){
                    let t = `
                      <div style="display: flex;align-items: center;margin-bottom: 8px">
                        <div style="width: 8px;height: 8px;background: ${params[i].color};border-radius: 50%;"></div>
                        <div style="color: #000E2B;font-size: 16px;margin-left: 4px;line-height: 16px;">${params[i].seriesName}：${params[i].value}亩</div>  
                      </div>
                    `
                    targetStr.push(t);
                  };
                  let result = `
                    <div style="padding: 12px;z-index:1001">
                      <div style="color: #3E3E3E;font-size: 16px;">${item.axisValue}</div>
                      <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                      ${targetStr.join('')}
                    </div>
                  `;
                  return result;
                }
              },
              grid: {
                left: '0',
                right: '10%',
                bottom: '0',
                top: '15%',
                containLabel: true
              },
              xAxis: {
                axisLabel: { //调整x轴的lable
                  textStyle: {
                    color: '#fff',
                    fontSize: 16,
                  },
                  formatter: function(value){
                    return +value > 10000 ? parseInt((+value)/10000) + '万+' : value
                  }
                },
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'category',
                data: yName,
                axisTick : {show: true},
                axisLabel: {
                  textStyle: {
                    color: '#fff',
                    fontSize: 16,
                  }
                },
                splitLine: {
                  show: false
                }
              },
              series: seriesData
            };
            this.init(option);
          });
        })
      },
      getSeriesItem(name, index, data) {
        return {
          name: name,
          type: 'bar',
          stack: '总量',
          color: this.colorSty[index],
          barWidth : 20,
          label: {
            normal: {
              show: false,
              position: 'insideRight'
            }
          },
          data: data
        }
      }
    }
  }
</script>
<style scoped lang="less">
  .container {
    position: relative;
    width: 100%;
    height: 558px;
    .tag-sty {
      width: 100%;
      height: 16px;
      .tag-item {
        height: 100%;
        font-size: 18px;
        font-weight: 400;
        color: rgba(255,255,255,0.6);
        margin-right: 16px;
        .tz {
          width: 16px;
          height: 6px;
          opacity: 0.8;
          margin-right: 8px;
        }
      }
    }
    .pie-sty {
      position: relative;
      width: 100%;
      height: 210px;
      margin-top: 20px;
      .con {
        position: relative;
        z-index: 0;
        width: 100%;
        height: 210px;
      }
      .show-part {
        position: absolute;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 40%;
        height: 40%;
        .sm {
          width: 100%;
          .s-title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(255,255,255,0.702);
            line-height: 18px;
            text-align: center;
          }
          .s-con {
            font-size: 24px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 24px;
            text-align: center;
            margin-top: 10px;
            .t {
              font-size: 18px;
              font-weight: 400;
              color: #FFFFFF;
              margin-left: 6px;
            }
          }
      }
      }
    }
    .line-sty {
      position: relative;
      width: 100%;
      height: 260px;
      .con {
        width: 100%;
        height: 260px;
      }
    }
  }
</style>